import axios from "axios";
// `params.mark_reviewed: 1` = the store is OPENING this listing (detail / edit
// page): clears the auto-created "never reviewed" dot. Background fetches omit it.
export async function getListing(listingId, params) {
  const response = await axios.get(`/api/listings/${listingId}`, params ? { params } : undefined);

  return response.data;
}

export async function importListing(listingId) {
  const response = await axios.post(`/api/listings/${listingId}/import`);

  return response.data;
}
